import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const Svg6571 = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 300,
	height: 281,
	viewBox: "0 0 300 281",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M7.896 162.965C-14.5972 110.617 12.6136 50.9008 68.5995 29.6196L126.638 7.56399C182.661 -13.7297 246.324 11.4793 268.805 63.8019L292.105 118.035C314.598 170.389 287.381 230.099 231.395 251.38L173.357 273.436C117.34 294.73 53.677 269.521 31.1963 217.204L7.896 162.965Z",
			fill: "url(#paint0_linear_43_124)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M28 252H38",
			stroke: "black",
			strokeWidth: 6,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M48 252H219.5",
			stroke: "black",
			strokeWidth: 6,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M234.5 252H259.5",
			stroke: "black",
			strokeWidth: 6,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M268.5 252H272",
			stroke: "black",
			strokeWidth: 6,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 87,
			y: 45.9999,
			width: 126,
			height: 206,
			rx: 9,
			fill: "#EFEFEF",
			stroke: "black",
			strokeWidth: 6
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M135.711 35.1621C136.824 33.4942 138.697 32.4926 140.702 32.4926H159.269C161.274 32.4926 163.146 33.4942 164.259 35.1621L166.252 38.1474C168.912 42.1346 166.054 47.4779 161.261 47.4779H138.71C133.916 47.4779 131.058 42.1346 133.719 38.1474L135.711 35.1621Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 98,
			y: 119,
			width: 112,
			height: 130,
			rx: 6,
			fill: "url(#paint1_linear_43_124)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M110.228 119C112.368 113.711 117.383 110 123.228 110C129.073 110 134.088 113.711 136.228 119",
			stroke: "black",
			strokeWidth: 6,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M131.238 92C129.017 89.5197 126.025 88 122.733 88C119.442 88 116.45 89.5197 114.228 92",
			stroke: "black",
			strokeWidth: 3,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M185.238 92C183.017 89.5197 180.025 88 176.733 88C173.442 88 170.45 89.5197 168.228 92",
			stroke: "black",
			strokeWidth: 3,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M173 150C168.884 157.052 159.24 162 148 162C136.76 162 127.116 157.052 123 150",
			stroke: "black",
			strokeWidth: 6,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M164.228 119C166.368 113.711 171.383 110 177.228 110C183.073 110 188.088 113.711 190.228 119",
			stroke: "black",
			strokeWidth: 6,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint0_linear_43_124",
			x1: 150,
			y1: 0,
			x2: 150,
			y2: 281,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#A0AB18" }), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#A0AB18",
				stopOpacity: .25
			})]
		}), /* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint1_linear_43_124",
			x1: 154,
			y1: 119,
			x2: 154,
			y2: 249,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#DCE239" }), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#B0BC28"
			})]
		})] })
	]
});
export default Svg6571;
